import React from 'react'
import { FaCheck } from 'react-icons/fa'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import CardMsgWithIcon from '@/components/CardMsgWithIcon'
import FormRegisterNewDoctorOrSecretary from '@/components/FormRegisterNewDoctorOrSecretary'
import { useUser } from '@/context/UserProvider'
import Layout1 from '@/layouts/Layout1'

import CustomErrorCard from './CustomErrorCard'

import s from './styles.module.scss'

const LinkDoctorOrSecretaryRegisterPage = () => {
  const { pathname } = useLocation()
  const { user, logout } = useUser()
  const { verificationStatus } = useSelector((state) => state.users)

  const role = pathname.includes('profesional') ? 'doctor' : 'secretary'
  const typeOfUser = pathname.includes('profesional') ? 'profesional' : 'secretaria'

  const getContent = () => {
    if (user) {
      return (
        <CustomErrorCard
          title="Error! Ya estás utilizando una cuenta"
          text1="Por favor desconectate de la cuenta actual para poder crear una nueva cuenta utilizando el email al que te invitaron"
          textButton="Salir de la cuenta actual"
          onClick={() => logout()}
        />
      )
    }
    if (verificationStatus) {
      return (
        <CardMsgWithIcon
          icon={<FaCheck />}
          iconClass="greenColor"
          title="Cuenta creada correctamente"
          text="Ya puedes acceder al sistema haciendo clic en INGRESAR"
          textButton="INGRESAR"
          path="/ingresar"
        />
      )
    }

    return <FormRegisterNewDoctorOrSecretary role={role} typeOfUser={typeOfUser} />
  }

  return (
    <Layout1 navbar isLoading={false}>
      <div className={s.container}>{getContent()}</div>
    </Layout1>
  )
}

export default LinkDoctorOrSecretaryRegisterPage
